import React from 'react';
import CourseIcon from './CourseIcon';

// Cover image slot for course cards. Shows the uploaded cover_image, or a branded
// placeholder (the course icon on a tinted gradient) when none is set.
const CourseCover = ({ src, alt, icon }) => (
  <div className="cc-cover">
    {src ? (
      <img src={src} alt={alt || ''} loading="lazy" />
    ) : (
      <div className="cc-cover-ph" aria-hidden="true">
        <CourseIcon icon={icon} className="cc-cover-ph-icon" />
      </div>
    )}
  </div>
);

export default CourseCover;
